import type { TConsentRequiredPayload } from '@/features/consent/types';

type TConsentRequiredListener = (consent: TConsentRequiredPayload['consent']) => void;

// Мостик между интерцептором axios и React: 403 `consent_required` может прилететь
// из любого запроса, а открыть модалку должен один смонтированный в layout хост.
const listeners = new Set<TConsentRequiredListener>();

export const onConsentRequired = (listener: TConsentRequiredListener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export const emitConsentRequired = (consent: TConsentRequiredPayload['consent']) => {
  listeners.forEach((listener) => listener(consent));
}
